function validatePhone(event) {
  const val = event.target.value;
  let content = [];
  Array.from(val).map(letter=>{
    if(!isNaN(letter)) {
        content.push(letter);
    }
  });
  let string = content.join("");
  event.target.value = string;
}

function validateDecimalNumber(event) {
  const val = event.target.value;
  let content = [];
  Array.from(val).map(letter=>{
    let validNumber = new RegExp(/^\d*\.?\d*$/);
    if(validNumber.test(letter)) {
        content.push(letter);
    }
  });
  let string = content.join("");
  event.target.value = string;
}

function number_format(str) {
    if (str == null) str = 0;
    return parseFloat(str)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
}

export {
    validatePhone,
    number_format,
    validateDecimalNumber,
}